import React, {useState, useEffect, Fragment} from 'react'
import {useDispatch} from "react-redux"
import PropTypes from 'prop-types'

// Material-UI Core
import {makeStyles, withStyles} from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Box from '@material-ui/core/Box'

// Custom Component
import useLoading from "../Loading/useLoading"
// import FullScreenDialog from "../Dialog/FullScreenDialog"
import SaveWarnDialog from '../Dialog/SaveWarnDialog'

// Custom Style
import {blackColor, grayColor, blueColor, DodgerBlueColor} from '../../styles/jss/cmsMainStyle'
import tabMenu from '../../styles/jss/components/tabMenu/tabMenuStyle'

// Global Function
// import {getAdministrableRight, getModifyRight} from '../../global/userRight'

// Fetch Data
// import {getSubmissionType, getSubmissionStage, documentSubmissionSearch} from '../../dataSource/documentSubmission'



import Grid from '@material-ui/core/Grid'
import Tooltip from '@material-ui/core/Tooltip'
import Fab from '@material-ui/core/Fab'

// Material-UI Lab
// import ToggleButton from '@material-ui/lab/ToggleButton'

// Material-UI Icon
import MenuBookIcon from '@material-ui/icons/MenuBook'


const useStyles = makeStyles(theme => tabMenu(theme))

const SecordTabs = withStyles(theme => ({
	root: {
		minHeight: 3,
		borderTop: "1px solid " + grayColor[1],
		borderBottom: "1px solid " + grayColor[1],
	},

	indicator: {
		backgroundColor: DodgerBlueColor[8]
	}
}))(Tabs)

const SecordTab = withStyles((theme) => ({
	root: {
		textTransform: "none",
		minHeight: 3,
		minWidth: 72,
		fontWeight: theme.typography.fontWeightRegular,
		color: blackColor,
		fontSize: 15,
		
		paddingTop: theme.spacing(0),  
		paddingBottom: theme.spacing(0),

		marginTop: theme.spacing(0), 
		marginBottom: theme.spacing(0), 
		marginRight: theme.spacing(4),

		fontFamily: [
			"-apple-system",
			"BlinkMacSystemFont",
			'"Segoe UI"',
			"Roboto",
			'"Helvetica Neue"',
			"Arial",
			"sans-serif",
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"'
		].join(","),
		"&:hover": {
			color: blueColor[10],
			opacity: 1
		},
		"&$selected": {
			color: DodgerBlueColor[8],
			fontWeight: theme.typography.fontWeightMedium
		},
		"&:focus": {
			color: DodgerBlueColor[8]
		}
	},
	selected: {}
}))((props) => <Tab disableRipple {...props} />)


const a11yProps = index => {
	return {
		id: `submission-tab-${index}`,
		'aria-controls': `submission-tabpanel-${index}`,
	}
}


const TabPanel = props => {
	const {children, value, index, ...other} = props

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box p={1}>
					<div>{children}</div>
				</Box>
			)}
		</div>
	)
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
}


const TabMenu = props => {
	const {type, property, defaultTabValue, annotSaveChangeAction} = props
	const store = require('store')
	const classes = useStyles()
	const dispatch = useDispatch()
	
	// store.set('annotActive', false)

	const [tabValue, setTabValue] = useState(0)


	// Save Change Warning dialog control State
	const [saveWarnDialogOpen, setSaveWarnDialogOpen] = useState(false)
	const [saveWarnDialogData, setSaveWarnDialogData] = useState({
		dialogTitle: "",
		dialogContent: "",
		saveAction: "",
		dontSaveAction: "",
		cancelAction: ""
	})


	// Set Save Change Warning Dialog
	const buildSaveChangeWarningDialog = (data) => {
		setSaveWarnDialogData({
			dialogTitle: data.dialogTitle,
			dialogContent: data.dialogContent,
			saveAction: data.saveAction,
			dontSaveAction: data.dontSaveAction,
			cancelAction: data.cancelAction
		})
	}


	// Save Change Dialog Control Function
	const saveChangeWarningDialogHandleOpen = (data) => {
		buildSaveChangeWarningDialog(data)
		setSaveWarnDialogOpen(true)
	}

	const saveChangeWarningDialogHandleClose = () => {
		setSaveWarnDialogOpen(false)
	}


	// Action
	const saveChangeWarningAction = (newTabValue) => {
		saveChangeWarningDialogHandleOpen({
			dialogTitle: "Annotation Change Warning",
			dialogContent: "Do you want to save the change of annotation.",
			saveAction: saveChangeWarningSaveAnnotation(newTabValue),
			dontSaveAction: saveChangeWarningDontSaveAnnotation(newTabValue),
			cancelAction: saveChangeWarningCancelAction
		})
	}

	const saveChangeWarningSaveAnnotation = (newTabValue) => () => {
		saveChangeWarningCancelAction()

		annotSaveChangeAction().then(() => {
			store.set('annotActive', false)
			setTabValue(newTabValue)
		})
	}

	const saveChangeWarningDontSaveAnnotation = (newTabValue) => () => {
		saveChangeWarningCancelAction()

		store.set('annotActive', false)
		setTabValue(newTabValue)
	}

	const saveChangeWarningCancelAction = () => {
		saveChangeWarningDialogHandleClose()
	}


	const handleTabChange = (event, newTabValue) => {
		if (!store.get('annotActive')) {
			setTabValue(newTabValue)
		}
		else {
			saveChangeWarningAction(newTabValue)
		}
	}


	const instructionDownload = (fileUrl, fileName) => () => {
		var a = document.createElement("a")
		a.href = fileUrl
		a.setAttribute("download", fileName)
		a.click()
	}

	useEffect(() => {
		dispatch({
			type: "SET_TABMENU_CHANGE",
			data: handleTabChange
		})

		if (isNaN(defaultTabValue)) {
			setTabValue(0)
		}
		else {
			setTabValue(defaultTabValue)
		}
	}, [])


	return (
		<Fragment>
			<div>
				<SaveWarnDialog
					open={saveWarnDialogOpen}
					dialogTitle={saveWarnDialogData.dialogTitle}
					dialogContent={saveWarnDialogData.dialogContent}
					saveAction={saveWarnDialogData.saveAction}
					dontSaveAction={saveWarnDialogData.dontSaveAction}
					cancelAction={saveWarnDialogData.cancelAction}
				/>
			</div>

			{type === "primary" ? 
				<div className={classes.root}>
					<AppBar position="static" color="default" >
						<Tabs value={tabValue} onChange={handleTabChange} aria-label="primary-tabs" textColor="primary" indicatorColor="primary">
							{
								property.map((prop, index) => {
									return (
										<Tab label={prop.name} {...a11yProps(prop.tabIndex)} key={index} />
									)
								})
							}

							<div className={classes.MenuBar}>
								<Tooltip title="Download Instruction Guide" >
									<Fab 
										aria-label="download_instruction_guide"
										color="primary"
										size="small"
										// onClick={download("https://cmsuat.sanfield.com.hk/file/dr20210721.pptx", "drawingRegister.pptx")}
										onClick={instructionDownload(window.location.protocol + "//" + window.location.hostname + "/file/dr20210721.pptx", "drawingRegister.pptx")}
										className={classes.toolMenuBtn}
									>
										<MenuBookIcon />
									</Fab>
								</Tooltip>
							</div>

						</Tabs>
					</AppBar>
					{
						property.map((prop, index) => {
							return (
								<TabPanel value={tabValue} index={prop.tabIndex} key={index}>
									{prop.form}
								</TabPanel>
							)
						})
					}
				</div>

			: type === "secord" ?

				<div className={classes.secordRoot}>
					<SecordTabs value={tabValue} onChange={handleTabChange} aria-label="secord-tabs">
							{
								property.map((prop, index) => {
									return (
										<SecordTab label={prop.name} {...a11yProps(prop.tabIndex)} key={index} />
									)
								})
							}
					</SecordTabs>
					{
						property.map((prop, index) => {
							return (
								<TabPanel value={tabValue} index={prop.tabIndex} key={index}>
									{prop.form}
								</TabPanel>
							)
						})
					}
				</div>
			:
				<div></div>
			}
		</Fragment>
	)
}


export default TabMenu